<template>
  <el-dialog
      title=""
      :visible.sync="visible"
      width="420px"
      center
      :show-close="false"
      custom-class="vip-premium-dialog"
      :before-close="handleClose">
    <div class="vip-premium-content">
      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </div>
      <!-- 顶部装饰 -->
      <div class="vip-header-decoration">
        <div class="crown-icon">
          <i class="el-icon-medal"></i>
        </div>
        <div class="sparkles">
          <span></span><span></span><span></span>
        </div>
      </div>
      <!-- 标题 -->
      <h3 class="vip-title">温馨提示</h3>
      <!-- 提示信息 -->
      <div class="vip-message-box">
        <i class="el-icon-info"></i>
        <p>{{ content }}</p>
      </div>
      <!-- SVIP提示 -->
      <div class="vip-svip-tip" v-if="showSvipTip">
        <i class="el-icon-warning-outline"></i>
        <span>SVIP指的是年会员或者终身会员</span>
      </div>
      <!-- 特权列表 -->
      <div class="vip-benefits">
        <div class="benefit-item">
          <i class="el-icon-document"></i>
          <span>海量试卷</span>
        </div>
        <div class="benefit-item">
          <i class="el-icon-monitor"></i>
          <span>会员试卷</span>
        </div>
        <div class="benefit-item">
          <i class="el-icon-edit"></i>
          <span>专享练习</span>
        </div>
        <div class="benefit-item">
          <i class="el-icon-s-data"></i>
          <span>数据分析</span>
        </div>
      </div>
      <!-- 升级按钮 -->
      <el-button class="upgrade-btn" @click="handleUpgrade">
        <i class="el-icon-unlock"></i>
        <span>立即升级会员</span>
      </el-button>
      <!-- 底部提示 -->
      <p class="vip-tip">开通VIP会员，解锁更多功能</p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VipUpgradeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: '此作品未开通权限，不可操作！'
    },
    showSvipTip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    handleUpgrade() {
      this.$emit('update:visible', false)
      this.$emit('upgrade')
    }
  }
}
</script>

<style lang="scss">
/* VIP高级弹窗样式 */
.vip-premium-dialog {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.vip-premium-content {
  position: relative;
  text-align: center;
  padding: 30px 30px 25px;
  background: linear-gradient(180deg, #fffbf5 0%, #ffffff 100%);

  // 关闭按钮
  .close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.3s ease;
    background: rgba(0, 0, 0, 0.04);

    i {
      font-size: 16px;
      color: #999;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.08);
      transform: rotate(90deg);
      i {
        color: #666;
      }
    }
  }

  // 顶部装饰
  .vip-header-decoration {
    position: relative;
    margin-bottom: 15px;

    .crown-icon {
      width: 70px;
      height: 70px;
      margin: 0 auto;
      background: linear-gradient(135deg, #ffd700 0%, #ffaa00 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 8px 25px rgba(255, 170, 0, 0.35);

      i {
        font-size: 36px;
        color: #fff;
      }
    }

    .sparkles {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 120px;
      height: 70px;

      span {
        position: absolute;
        width: 6px;
        height: 6px;
        background: #ffd700;
        border-radius: 50%;
        animation: sparkle 1.5s ease-in-out infinite;

        &:nth-child(1) {
          top: 5px;
          left: 15px;
          animation-delay: 0s;
        }
        &:nth-child(2) {
          top: 10px;
          right: 15px;
          animation-delay: 0.5s;
        }
        &:nth-child(3) {
          top: 35px;
          left: 5px;
          animation-delay: 1s;
        }
      }
    }
  }

  // 标题
  .vip-title {
    font-size: 22px;
    font-weight: 700;
    color: #333;
    margin: 0 0 15px;
    letter-spacing: 1px;
  }

  // 提示信息框
  .vip-message-box {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #fff8e6 0%, #fff3d6 100%);
    border: 1px solid #ffe4a0;
    border-radius: 10px;
    padding: 12px 18px;
    margin-bottom: 15px;

    i {
      font-size: 18px;
      color: #f5a623;
      margin-right: 10px;
      flex-shrink: 0;
    }

    p {
      margin: 0;
      font-size: 14px;
      color: #8b6914;
      line-height: 1.5;
      text-align: left;
    }
  }

  // SVIP提示
  .vip-svip-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 8px;
    padding: 10px 16px;
    margin-bottom: 15px;
    font-size: 13px;
    color: #856404;

    i {
      color: #f39c12;
      font-size: 15px;
      margin-right: 8px;
    }
  }

  // 特权列表
  .vip-benefits {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-bottom: 20px;

    .benefit-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px 5px;
      background: #fff;
      border-radius: 10px;
      border: 1px solid #f0f0f0;
      transition: all 0.3s ease;

      i {
        font-size: 22px;
        color: #ffaa00;
        margin-bottom: 6px;
      }

      span {
        font-size: 12px;
        color: #666;
        white-space: nowrap;
      }

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 5px 15px rgba(255, 170, 0, 0.15);
        border-color: #ffd700;
      }
    }
  }

  // 升级按钮
  .upgrade-btn {
    width: 100%;
    height: 48px;
    border-radius: 24px;
    font-size: 16px;
    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
    border: none;
    color: #fff;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 6px 20px rgba(238, 90, 36, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: 18px;
      margin-right: 8px;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(238, 90, 36, 0.45);
      background: linear-gradient(135deg, #ff7b7b 0%, #ff6a34 100%);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 4px 15px rgba(238, 90, 36, 0.35);
    }
  }

  // 底部提示
  .vip-tip {
    margin: 15px 0 0;
    font-size: 12px;
    color: #999;
  }
}

// 闪光动画
@keyframes sparkle {
  0%, 100% {
    opacity: 0;
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
